// Generated by CoffeeScript 1.12.7
(function () {
  var Exception;

  module.exports.Exception = Exception = function () {
    function Exception(message, wrapped) {
      this.message = message;
      this.wrapped = wrapped;
    }

    return Exception;
  }();
}).call(this);